import React from 'react';

import { Box } from '@mui/system';

import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { setDialog } from '../../../../reducers/dialogReducer';
import GroupHeaderBase from '../../../common/Chat/GroupHeaderBase';
import strings from '../../../../localization';

import CreateGroupDialog from '../CreateGroupDialog';

const GroupHeader = () => {
  const dispatch = useAppDispatch();

  const showDialog = () => {
    dispatch(
      setDialog({
        showCloseButton: true,
        heading: {
          title: strings.newChat,
        },
        maxWidth: 'sm',
        Component: <CreateGroupDialog />,
      }),
    );
  };

  return (
    <Box>
      <GroupHeaderBase showDialog={showDialog} />
    </Box>
  );
};

export default GroupHeader;
